"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _excluded = ["amount", "min", "max", "offset", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The ProgressBar component provides visual feedback on the progress of an activity.
 */
var ProgressBar = function ProgressBar(_ref) {
  var amount = _ref.amount,
      min = _ref.min,
      max = _ref.max,
      offset = _ref.offset,
      className = _ref.className,
      attributes = _objectWithoutPropertiesLoose(_ref, _excluded);

  var range = max - min;
  var percentage = (amount - min) * 100 / range;
  var offsetPercentage = (offset - min) * 100 / range;
  var amountValue = {
    width: Math.min(Math.max(percentage, 0), 100) + "%",
    marginLeft: offsetPercentage + "%"
  };
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _clsx.default)('uk-progress-bar', className),
    role: "progressbar",
    tabIndex: "0",
    "aria-valuenow": amount,
    "aria-valuemin": min,
    "aria-valuemax": max
  }, attributes), /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-progress-meter",
    style: amountValue
  }));
};

ProgressBar.propTypes = {
  /**
   * Current value of the ProgressBar, should be between low and high values.
   */
  amount: _propTypes.default.number,
  offset: _propTypes.default.number,

  /**
   * Minimum value, represents the progressBar at 0%.
   */
  min: _propTypes.default.number,

  /**
   * Maximum value, represents the progressBar at 100%.
   */
  max: _propTypes.default.number
};
ProgressBar.defaultProps = {
  amount: 0,
  min: 0,
  max: 100
};
var _default = ProgressBar;
exports.default = _default;